import React, { useEffect, useState, useRef, useCallback } from 'react';

import { dataJson } from './document-category'

import '../../../../App.css'
import AsyncSelect from 'react-select/async';
import { multipleUploadStatement, getBankList, uploadSupportDocument } from '../../../../redux/actions/b2b_action';
import { multipleUploadStatementProd, getBankListProd, uploadSupportDocumentProd } from '../../../../redux/actions/prod-b2b_action';

import Loader from '../../../loader/loader';
// import { uuid } from '../../Utils/uuid';
import { v4 as uuidv4 } from 'uuid';
import { passwordRegexWithoutLength } from '../../../../utils/regex-patterns';

const IC_EYE = require("../../../../images/assets/ic_eye.png")
const IC_EYE_OFF = require("../../../../images/assets/ic_eye_close.png")
const IC_ARROW = require("../../../../images/assets/ic-arrow.png")
const UploadCloud = require("../../../../images/assets/upload_cloud.png");


const UploadMultiDocs = (props) => {
    const [uploadError, setUploadError] = useState(false);
    const [uploadErrMsg, setUploadErrMsg] = useState();
    // State for form handling
    const [submitBtnEnable, setSubmitBtnEnable] = useState(false);
    const [loader, setLoader] = useState(false);
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [documentTypes, setDocumentTypes] = useState([]);
    const [selectedDocument, setSelectedDocument] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [isPasswordProtected, setIsPasswordProtected] = useState(false);
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [uploadedDocs, setUploadedDocs] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [selectedDocumentDetails, setSelectedDocumentDetails] = useState(null);
    const fileInputRef = useRef(null);
    const [localFiles, setLocalFiles] = useState([]);
    const [dragging, setDragging] = useState(false);

    // Load categories on component mount
    useEffect(() => {
        if (dataJson && dataJson.length > 0) {
            const categoryOptions = dataJson[0].documentsRequired.map(item => ({
                label: item.documentCategory,
                value: item.documentCategory,
            }));
            setCategories(categoryOptions);
        }
    }, []);

    // Update document types when a category is selected
    useEffect(() => {
        if (selectedCategory) {
            const categoryData = dataJson[0].documentsRequired.find(
                item => item.documentCategory === selectedCategory
            );

            if (categoryData) {
                const allDocs = [
                    ...categoryData.documents,
                    ...categoryData.documentsToChooseFrom
                ];

                const docOptions = allDocs.map(doc => ({
                    label: doc.documentLabel,
                    value: doc.documentType,
                    description: doc.description,
                    isMandatory: doc.isMandatory,
                    inputType: doc.inputType,
                    details: doc
                }));

                setDocumentTypes(docOptions);
            } else {
                setDocumentTypes([]);
            }
            setErrorMessage('');
            // Reset document selection when category changes
            setSelectedDocument('');
            setSelectedDocumentDetails(null);
            setSelectedFile(null);
        } else {
            setDocumentTypes([]);
        }
    }, [selectedCategory]);

    // Check if form is valid to enable submit button
    useEffect(() => {
        if (selectedCategory && selectedDocument && selectedDocumentDetails) {
            if (selectedDocumentDetails.inputType === 'file' && !selectedFile) {
                setSubmitBtnEnable(false);
            } else if (isPasswordProtected && !password) {
                console.log("isPasswordProtected")
            } else {
                setSubmitBtnEnable(true);
            }
            setErrorMessage('');
        } else {
            setSubmitBtnEnable(false);
        }
    }, [selectedCategory, selectedDocument, selectedDocumentDetails, selectedFile, isPasswordProtected, password]);

    // Handle file selection
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedFile(file);
            setErrorMessage('');
        }
    };

    const handleDragOver = (event) => {
        event.preventDefault();
        setDragging(true);
    };

    const handleDragEnter = (event) => {
        event.preventDefault();
        setDragging(true);
    };

    const handleDragLeave = () => {
        setDragging(false);
    };

    const handleDrop = (event) => {
        event.preventDefault();
        setDragging(false);
        const file = event.dataTransfer.files[0];
        if (file) {
            setSelectedFile(file);
            setErrorMessage('');
        }
    };

    // Handle category selection
    const handleCategoryChange = (e) => {
        setErrorMessage('');
        setSelectedCategory(e.target.value);
    };

    const handleChooseFilesClick = () => {
        fileInputRef.current.click();
    };

    // Handle document type selection
    const handleDocumentChange = (e) => {

        const docValue = e.target.value;
        setSelectedDocument(docValue);

        // Find the full document details for the selected document
        const docDetails = documentTypes.find(doc => doc.value === docValue);
        setSelectedDocumentDetails(docDetails ? docDetails.details : null);

        setSelectedFile(null);
        setErrorMessage('');
    };

    // Toggle password visibility
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const resetUploadForm = () => {
        setSelectedDocument('');
        setSelectedDocumentDetails(null);
        setSelectedFile(null);
        setIsPasswordProtected(false);
        setPassword('');
        setErrorMessage('');
    };

    // Handle upload submission
    const handleUpload = async () => {
        if (!submitBtnEnable) return;

        // Validate form
        if (!selectedCategory) {
            setErrorMessage('Please select a document category');
            return;
        }

        if (!selectedDocument || !selectedDocumentDetails) {
            setErrorMessage('Please select a document type');
            return;
        }

        if (selectedDocumentDetails.inputType === 'file' && !selectedFile) {
            setErrorMessage('Please select a file to upload');
            return;
        }

        if (isPasswordProtected && !password) {
            setErrorMessage('Please enter the password for the file');
            return;
        }
        if (isPasswordProtected && password && !passwordRegexWithoutLength.test(password)) {
            setErrorMessage('Password allows special character only !@$%_-+.,^');
            return;
        }
        setLoader(true);
        if (props.onUploadStart) {
            await props.onUploadStart();  // <--- await is key here
        }
        // Create upload data
        const uploadData = {
            id: uuidv4(),
            category: selectedCategory,
            documentType: selectedDocument,
            documentLabel: selectedDocumentDetails.documentLabel,
            file: selectedFile,
            isPasswordProtected: isPasswordProtected,
            password: isPasswordProtected ? password : '',
            uploadDate: new Date().toISOString()
        };
        const applicationId = props.applicationIDRef?.current || '';
        let param = new FormData();
        param.append("businessUserId", props.businessUserId);
        param.append("password", isPasswordProtected ? password : '');
        param.append("documentType", selectedDocument);
        param.append("documentCategory", selectedCategory);
        param.append("file", selectedFile);
        param.append("applicationId", applicationId);



        const apiFn = props.isFromProduction ? uploadSupportDocumentProd : uploadSupportDocument;

        await apiFn(param).then(resp => {
            setLoader(false);
            if (resp.statusCode === 'SUCCESS') {
                resetUploadForm();
                if (props.onUploadComplete) {
                    props.onUploadComplete(uploadData);
                }
            } else {
                setErrorMessage(resp?.statusMessage);
            }

        }).catch((error) => {
            setErrorMessage(error?.response?.data?.errorMessage);
        })

    };

    return (
        <>
            {loader && <Loader />}
            <div className='container-box'>
                <div className="col-12 d-flex flex-wrap justify-content-between">
                    {/* Category Selection - Using Standard Dropdown */}
                    <div className='col-12 col-lg-6 px-2 py-1'>
                        <div className="label-label mb-2">Category of Documents</div>
                        <select
                            className="form-select"
                            value={selectedCategory}
                            onChange={handleCategoryChange}
                            style={{ height: "48px", fontFamily: 'Poppins', fontSize: '14px' }}
                        >
                            <option value="">Select category</option>
                            {categories.map((category, index) => (
                                <option key={index} value={category.value}>
                                    {category.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Document Type Selection - Using Standard Dropdown */}
                    <div className='col-12 col-lg-6 px-2 py-1'>
                        <div className="label-label mb-2">Type of Documents</div>
                        <select
                            className="form-select"
                            value={selectedDocument}
                            onChange={handleDocumentChange}
                            disabled={!selectedCategory}
                            style={{ height: "48px", fontFamily: 'Poppins', fontSize: '14px' }}
                        >
                            <option value="">Select document</option>
                            {documentTypes.map((docType, index) => (
                                <option key={index} value={docType.value}>
                                    {docType.label} {docType.isMandatory && ''}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="col-12 d-flex flex-column justify-content-between mt-3">
                    {/* Enhanced File Upload Area with Drag & Drop */}
                    <div className='col-12 col-lg-12 px-2 py-1'>
                        <div className="label-label mb-2">
                            Upload File {selectedDocumentDetails && selectedDocumentDetails.isMandatory && <span className="text-danger">*</span>}
                        </div>

                        {/* Drag and Drop Area */}
                        <div
                            className={`drag-drop-area ${dragging ? 'dragging' : ''}`}
                            onDragOver={handleDragOver}
                            onDragEnter={handleDragEnter}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDrop}
                            onClick={handleChooseFilesClick}
                            style={{
                                border: `2px dashed ${dragging ? '#007bff' : '#ccc'}`,
                                borderRadius: '8px',
                                padding: '20px 20px',
                                textAlign: 'center',
                                cursor: 'pointer',
                                backgroundColor: dragging ? 'rgba(0, 123, 255, 0.05)' : '#f8f9fa',
                                transition: 'all 0.3s ease',
                                minHeight: '120px',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <img
                                src={UploadCloud}
                                alt="Upload"
                                style={{ width: '48px', height: '48px', marginBottom: '10px' }}
                            />

                            {selectedFile ? (
                                <div className="selected-file-container">
                                    <div className="selected-file-info">
                                        <i className="bi bi-file-earmark me-2"></i>
                                        <span className="file-name">{selectedFile.name}</span>
                                        <span className="file-size ms-2">({(selectedFile.size / 1024).toFixed(2)} KB)</span>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <p style={{ margin: '10px 0', fontWeight: '500' }}>Drag & Drop file here or</p>
                                    <button
                                        type="button"
                                        className="btn btn-sm"
                                        style={{
                                            fontWeight: '500', border: '1px solid #4243F1',
                                            color: "#4243F1"
                                        }}
                                    >
                                        Browse Files
                                    </button>
                                    <p style={{ fontSize: '12px', color: '#6c757d', marginTop: '10px' }}>
                                        Supported formats: PDF, JPG, PNG, JPEG
                                    </p>
                                </>
                            )}

                            <input
                                type="file"
                                accept=".pdf, .jpg, .png, .jpeg"
                                ref={fileInputRef}
                                onChange={handleFileChange}
                                style={{ display: 'none' }}
                            />
                        </div>
                    </div>

                    {/* Password Protection Section */}
                    <div className='col-12 col-lg-12 px-2 py-1 mt-3'>
                        <div className="form-check mb-2">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="passwordProtection"
                                checked={isPasswordProtected}
                                onChange={(e) => setIsPasswordProtected(e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="passwordProtection">
                                File is Password Protected
                            </label>
                        </div>

                        <div className="password-field-container position-relative">
                            <input
                                type={showPassword ? "text" : "password"}
                                className="form-control"
                                placeholder="Enter file password"
                                value={password}
                                disabled={!isPasswordProtected}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <button
                                type="button"
                                className="btn btn-link password-toggle-btn position-absolute"
                                style={{ right: '5px', top: '50%', transform: 'translateY(-50%)', border: 'none', background: 'none' }}
                                onClick={togglePasswordVisibility}
                            >
                                <img
                                    src={showPassword ? IC_EYE_OFF : IC_EYE}
                                    alt={showPassword ? "Hide password" : "Show password"}
                                    style={{ width: 'auto', height: '20px' }}
                                />
                            </button>
                        </div>
                    </div>
                </div>

                {/* Error Messages */}
                {errorMessage && (
                    <div className="col-12 mt-2">
                        <div className="alert alert-danger" role="alert">
                            {errorMessage}
                        </div>
                    </div>
                )}

                {/* Description area - show if document is selected */}
                {selectedDocumentDetails && (
                    <div className="col-12 mt-3">
                        <div className="document-description alert alert-info">
                            <i className="bi bi-info-circle me-2"></i>
                            {selectedDocumentDetails.description || `Please upload your ${selectedDocumentDetails.documentLabel}`}
                        </div>
                    </div>
                )}

                {/* Upload Button */}
                <div className="col-12 mt-3 text-center">
                    <button className='mb-0 mt-3 next-button'
                        onClick={handleUpload}
                        disabled={!submitBtnEnable}
                    >Submit Documents</button>
                </div>
            </div>
        </>
    );
};



export default UploadMultiDocs;